import { useEffect, useState } from 'react'

import { widths } from 'shared/constants/values'

export const useResize = () => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    width,
    isMobile: width <= widths.mobile,
    isSTablet: width <= 640,
    isTablet: width <= widths.tablet,
    isSDesktop: width <= 1280,
    isDesktop: width > 1440,
  }
}
